import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-wrap my-6 space-y-2 md:space-y-0 md:space-x-2 md:flex-nowrap" }
const _hoisted_2 = { class: "flex w-full md:w-1/4" }
const _hoisted_3 = {
  value: "all",
  selected: ""
}
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "flex justify-center" }

import { ref, onMounted, PropType } from "vue";
import { useI18n } from "vue-i18n";

import { Goal } from "@/types";
import { goalCategories } from "@/utils/constants";
import capitalize from "@/utils/capitalize";


export default /*#__PURE__*/_defineComponent({
  __name: 'GoalProgressChart',
  props: {
  goals: {
    type: Object as PropType<Goal[]>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const { t: $t } = useI18n();

const showChart = ref(false);



const categoriesList = goalCategories.map(category => {
  return {
    value: capitalize($t(category)),
  };
});

const chartOptions = ref({
  chart: {
    id: "progress-goal",
    type: "line",
  },
  xaxis: {
    categories: [],
  },
  yaxis: {
    min: 0,
    max: 10,
  },
  title: {
    text: $t("goal-progression"),
  },
  annotations: {
    yaxis: [
      {
        y: 8.0,
        borderStyle: "dashed",
        borderColor: "#000",
        label: {
          borderColor: "#000",
          style: {
            color: "#fff",
            background: "#000",
          },
          text: "Score of 8 or over can be considered achieved",
        },
      },
    ],
  },
  stroke: {
    curve: "smooth",
    width: 4,
  },
  colors: ["#FF351F", "#347659", "#6475F5", "FF8F63", "#929421", "#CFA6F5", "#ECB31C"],
});

const series = ref([]);

const filter = ref("all");

function filterChart() {
  showChart.value = false;
  setTimeout(() => {
    showChart.value = true;
  }, 100);
}

function getProgressData(progress: any, dates: any) {
  let progressData: null[] = [];
  dates.forEach((date: string) => {
    const index = progress.findIndex((p: any) => new Date(p.date.date).toLocaleDateString() === date);
    if (index !== -1) {
      progressData.push(progress[index].progress);
    } else {
      progressData.push(null);
    }
  });
  return progressData;
}

onMounted(() => {
  const activeDates = props.goals.map(goal => {
    return goal.progress.map(progress => {
      return new Date(progress!.date!.date);
    });
  });

  const activeDatesFlat = [
    ...new Set(
      activeDates
        .flat()
        .sort((a, b) => new Date(a).getTime() - new Date(b).getTime())
        .map(date => {
          return new Date(date).toLocaleDateString();
        })
    ),
  ];

  const seriesData = props.goals.map(goal => {
    return {
      name: goal.description,
      data: getProgressData(goal.progress, activeDatesFlat),
      category: goal.category,
    };
  });

  // @ts-ignore
  series.value = seriesData;

  // @ts-ignore
  chartOptions.value.xaxis.categories = activeDatesFlat;

  // @ts-ignore
  chartOptions.value.legend = {
    show: true,
    position: "bottom",
    horizontalAlign: "center",
    showForSingleSeries: true,
    showForNullSeries: true,
    showForZeroSeries: true,
  };

  showChart.value = true;
});

return (_ctx: any,_cache: any) => {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("select", {
          onChange: filterChart,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filter).value = $event)),
          id: "type",
          name: "type",
          class: "text-black border rounded w-full focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-400"
        }, [
          _createElementVNode("option", _hoisted_3, _toDisplayString(_unref($t)("all-categories")), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categoriesList), (t, index) => {
            return (_openBlock(), _createElementBlock("option", {
              key: index,
              value: t.value
            }, _toDisplayString(_unref($t)(t.value)), 9, _hoisted_4))
          }), 128))
        ], 544), [
          [_vModelSelect, filter.value]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (showChart.value)
        ? (_openBlock(), _createBlock(_component_apexchart, {
            key: 0,
            width: "800",
            type: "line",
            options: chartOptions.value,
            series: filter.value === 'all' ? series.value : series.value.filter(i => i.category.toLowerCase() === filter.value.toLowerCase())
          }, null, 8, ["options", "series"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})